module.exports = __webpack_public_path__ + "img/w3_olja_black.d366ade1.png";